import { BaseDocumentBloc } from "./bloc.base";
import environment from "@/config"
import { api } from '@cems-eco/core/src/services/api';
import { Document, UploadRequest } from "./model";

export class BoxDocumentBloc extends BaseDocumentBloc {
    base_url = '/document';

    getDocUrl(endpoint) {
        return `${environment.BASE_URL}/${endpoint}`;
    }
    
    getTableUrl(management_id) {
        const params = {
            search: {
                advanced: {
                    management_id
                }
            },
            orderBy: {
                created_at: "desc"
            },
            with: "user"
        }
        return api.getUrl(this.base_url, params);
    }
}

